import styled from '@emotion/styled';

export const MenuHomeContainer = styled.div`
    width: 100%;
`;

export const BottomBar = styled.div`
    padding: ${({ theme }) => theme.base.spacing[4]};
    background: ${({ theme }) => theme.base.color.backgroundMain};
    position: sticky;
    height: 90px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0;
    left: 0;
`;
